export default __webpack_public_path__ + "static/media/1583.c839b547.png";